import { useQueryClient } from '@tanstack/react-query';
import { InvalidationTag } from '../utils';
/**
 * Ritorna true se il leader autenticato è B2B.
 * Nel flusso di creazione membro il fetch del customer è disabilitato
 * (`useGetCustomerApi(!isFamilyMember)`), quindi legge il customer del leader
 * dalla cache di React Query già popolata prima di entrare nel flusso.
 */
export var useLeaderIsB2B = function () {
    var _a;
    var queryClient = useQueryClient();
    var customer = queryClient.getQueryData([
        InvalidationTag.Customer,
    ]);
    return ((_a = customer === null || customer === void 0 ? void 0 : customer.Subscription) === null || _a === void 0 ? void 0 : _a.channel) === 'B2B_CODE';
};
